import type { TIconKey } from "@/types";
import type React from "react";
import {
  ArrowUpCircle,
  Book,
  Bookmark,
  InfoCircle,
  Search,
} from "react-bootstrap-icons";

type TBootstrapIconComponent = React.ComponentType<{
  color?: string;
  size?: string | number;
  title?: string;
  className?: string;
}>;

export const navIconComponentMap: Record<TIconKey, TBootstrapIconComponent> = {
  info: InfoCircle,
  book: Book,
  bookmark: Bookmark,
  search: Search,
  up: ArrowUpCircle,
};
